// extracted by mini-css-extract-plugin
module.exports = {"container":"BorderCard_container__3l5BW","containerDashed":"BorderCard_containerDashed__1kNxv"};